<template>
  <el-button
    round
    class="base-text-button"
    :class="{ 'is-plain': plain, 'is-light': light }"
    :size="size"
    :round="round"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'BaseTextButton',
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    round: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: true
    },
    light: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-button.el-button {
  color: $--button-text-color;
  border-color: $--button-text-hover-border-color;
  background-color: $--button-text-hover-backgrounp-color;
  &:focus, &:hover {
    color: #fff;
    border-color: $--button-text-color;
    background-color: $--button-text-color;
  }
  &.is-plain {
    color: $--button-text-color;
    border-color: $--button-text-border-color;
    background-color: $--button-text-backgrounp-color;
    &:focus, &:hover {
      color: $--button-text-hover-color;
      border-color: $--button-text-hover-border-color;
      background-color: $--button-text-hover-backgrounp-color;
    }
  }
  &.is-light {
    color: $--button-text-color;
    border-color: #F9F9F9;
    background-color: #F9F9F9;
    &:focus, &:hover {
      color: $--button-text-color;
      border-color: #F1F1F1;
      background-color: #F1F1F1;
    }
  }
  &.el-button--mini.is-round {
    padding: 7px 10px;
  }
}
</style>
